export const ASSISTANT_MODULE = "ASSISTENTE_IA";
export const ASSISTANT_QUERY_KEY = ["assistant", "conversations"] as const;
export const MAX_MESSAGE_CHARS = 2000;

// Os nomes de módulo são os da tabela `modules` da API.
export const SUGGESTIONS_BY_MODULE: { module: string | null; text: string }[] =
  [
    { module: null, text: "Onde estão meus veículos agora?" },
    { module: null, text: "Quantos km a frota rodou nos últimos 30 dias?" },
    {
      module: "REL_DESPESAS",
      text: "Quanto gastei com manutenção no mês passado?",
    },
    {
      module: "CLI_ABASTECIMENTOS",
      text: "Qual o consumo médio em km/l da frota este mês?",
    },
    {
      module: "REL_EVENTOS",
      text: "Quantos excessos de velocidade tivemos esta semana?",
    },
    {
      module: "RANKING_CONDUCAO_FROTA",
      text: "Qual o ranking de condução dos motoristas no último mês?",
    },
  ];
